import { useState } from "react";
import { useTokensValues } from "../tokens";

export const useSendLegalAgreementsSms = () => {
  const [message, setMessage] = useState<string>("");
  const authenticityToken = useTokensValues().authenticityToken;
  const [isError, setIsError] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleSendSms = async () => {
    setIsLoading(true);
    const url = new URL(window.location.pathname, window.location.origin);
    url.searchParams.set("step_action", "send_legal_agreements_sms");
    const headers = {
      "X-CSRF-Token": authenticityToken || "",
      "Content-Type": "application/json",
      Accept: "application/json",
    };

    try {
      const response = await fetch(url, {
        method: "POST",
        headers,
        body: JSON.stringify({}),
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error("Server error response:", errorText);
        throw new Error(
          `Server returned ${response.status}: ${response.statusText}`,
        );
      }

      const data = (await response.json()) as { message: string };
      if (data.message === "Request for SMS has been submitted!") {
        setIsError(false);
      } else {
        setIsError(true);
      }
      setMessage(data.message);
    } catch (error) {
      console.error("Error sending SMS:", error);
      setIsError(true);
      setMessage("There was a problem submitting the request for SMS");
    } finally {
      setIsLoading(false);
    }
  };

  return { message, handleSendSms, isError, isLoading };
};
